// format . for thousands and , for decimals
export const formatNumber = {
  separador: '.', // separator for thousands
  sepDecimal: ',', // separator for decimals
  formatear(num) {
    const numStr = num.toString();
    const splitStr = numStr.split('.');
    let splitLeft = splitStr[0];
    const splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    const regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, `$1${this.separador}$2`);
    }
    return this.simbol + splitLeft + splitRight;
  },
  new(num, simbol) {
    this.simbol = simbol || '';
    return this.formatear(num);
  }
};
